import React from 'react'
import SetPasswordForm from 'pages/Identity/SetPasswordForm'

export default () => {
  return (
    <SetPasswordForm heading='Thank you for confirming your account.  Please create a password.' buttonText='Create Password' />
  )
}
